<template>
  <div>
    <common-Compontent :factorType="factorType" :category2="category2" :month="month"></common-Compontent>
  </div>
</template>
<script>
import commonCompontent from './commonVue.vue';
export default {
  name: 'govtPlantAudit',
  components: {
    commonCompontent
  },
  data() {
    return {
      factorType: 'GOVT_PLANT_AUDIT',
      category2: [],
      month: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    console.log('from', from);
    if (from.path === '/qspiTodo') {
      if (to.query.month) {
        next(vm => {
          vm.month.push(to.query.month)
          console.log('vm.month', vm.month);
        })
      }
      if (to.query.category2) {
        next(vm => {
          vm.category2.push(to.query.category2)
          console.log('vm.category2', vm.category2);
        })
      }
      if (!to.query.month && !to.query.category2) {
        next()
      }
    } else {
      next()
    }
  },
  created() {

  },
  methods: {

  }
}
</script>